import { LeadGenerationRequester } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { LEAD_REQUESTER_ICON, LEAD_REQUESTER_LABEL } from '../../../features/LeadGeneration/leadRequester';

const REQUESTERS = Object.values(LeadGenerationRequester);

/** Worker and customer, with their icons. */
export const LEAD_GENERATION_REQUESTER_FILTER_OPTIONS: FilterOption<LeadGenerationRequester>[] = REQUESTERS.map(
  (requester) => ({ value: requester, label: LEAD_REQUESTER_LABEL[requester], icon: LEAD_REQUESTER_ICON[requester] })
);
